import { CONTENTFUL_SPACE, CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN, APTABASE_APP_KEY } from "@env"
import Aptabase from "@aptabase/react-native"

export const ContentfulSpace = CONTENTFUL_SPACE
export const ContentfulContentDeliveryAccessToken = CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN

// async-storage key udner which the app settings are stored. Can be whatever and is not confidential
export const STORAGE_KEY = "@noid_schedule_app_settings103"

export const AptabaseAppKey = APTABASE_APP_KEY
